import { I18nManager } from 'react-native';
import styled from 'styled-components/native';

const Component = styled.View`
  flex-direction: ${() => (I18nManager.isRTL ? 'row-reverse' : 'row')};
  align-items: center;
`;

Component.displayName = 'RTLRow';

export default Component;
